import React from "react"
import useAuth from "hooks/useAuth"
import PropTypes from "prop-types"
import { Navigate } from "react-router-dom"

function CanView({ allowedUsers = [], renderAuthFailed, children }) {
  const { userData } = useAuth()

  if (allowedUsers.includes(userData.user_type)) {
    return children
  }

  if (renderAuthFailed) {
    return <Navigate to="/not-allowed" replace />
  }

  return null
}
CanView.propTypes = {
  allowedUsers: PropTypes.array.isRequired,
  children: PropTypes.node,
  renderAuthFailed: PropTypes.any,
}
export default CanView
